export default __webpack_public_path__ + "static/Corprate_WhoWeAre_InternationalFranchises_03-cde0b8ed1caa875ef9a4fced30f79c67.jpg";